import React from 'react';
import { Navigate, Route, useLocation } from 'react-router-dom';
import HealthRecordsHub from 'components/dashboard/HealthRecordsHub';
import DemographicsPage from 'pages/dashboard/individual/health-records/DemographicsPage';
import MedicalConditionsPage from 'pages/dashboard/individual/health-records/MedicalConditionsPage';
import SurgicalHistoryPage from 'pages/dashboard/individual/health-records/SurgicalHistoryPage';
import AllergiesPage from 'pages/dashboard/individual/health-records/AllergiesPage';
import OtherHistoryPage from 'pages/dashboard/individual/health-records/OtherHistoryPage';
import ShareHealthRecordsPage from 'pages/dashboard/individual/health-records/ShareHealthRecordsPage';
import FeatureGate from 'shared/components/FeatureGate';
import { masterChartLegacyRedirectTarget } from 'constants/masterChartRoutes';

function MasterChartLegacyRedirect() {
  const { pathname, search } = useLocation();
  return <Navigate to={masterChartLegacyRedirectTarget(pathname, search)} replace />;
}

/** Shared MasterChart hub + section routes (paths are relative to /dashboard).
 *  Invoke as `{MasterChartDashboardRoutes()}` inside `<Routes>` — not `<MasterChartDashboardRoutes />`,
 *  because React Router only accepts `<Route>` or `<Fragment>` as direct children of `<Routes>`.
 */
export function MasterChartDashboardRoutes() {
  return (
    <>
      <Route path="/masterchart" element={<HealthRecordsHub />} />
      <Route path="/masterchart/demographics" element={<DemographicsPage />} />
      <Route path="/masterchart/conditions" element={<MedicalConditionsPage />} />
      <Route path="/masterchart/surgical-history" element={<SurgicalHistoryPage />} />
      <Route
        path="/masterchart/allergies"
        element={
          <FeatureGate feature="allergies" showUpgradePrompt>
            <AllergiesPage />
          </FeatureGate>
        }
      />
      <Route path="/masterchart/other-history" element={<OtherHistoryPage />} />
      <Route path="/masterchart/share" element={<ShareHealthRecordsPage />} />
      <Route path="/health-records" element={<MasterChartLegacyRedirect />} />
      <Route path="/health-records/*" element={<MasterChartLegacyRedirect />} />
    </>
  );
}

export default MasterChartDashboardRoutes;
